import React, { useState } from 'react';
import { Gamepad2, Sparkles, Link2, Trophy, Wand2 } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const Game = () => {
  const [url, setUrl] = useState('');
  const [connected, setConnected] = useState('');
  const { toast } = useToast();

  const connect = (e) => {
    e.preventDefault();
    if (!url) return;
    setConnected(url);
    toast({ title: 'Game connected \u2728', description: 'Your game is now embedded on the site.' });
  };

  return (
    <div className="pt-28 pb-24 min-h-screen">
      <section className="relative py-12 overflow-hidden">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 h-[420px] w-[420px] rounded-full bg-[#d6197d]/15 blur-[120px] glow-pulse" />
        <div className="relative max-w-3xl mx-auto px-5 text-center">
          <Gamepad2 className="h-14 w-14 text-[#ff4da6] mx-auto mb-5 floaty" />
          <p className="font-jost text-xs tracking-[0.4em] text-[#ff4da6] uppercase mb-3">Interactive Experience</p>
          <h1 className="font-cinzel text-4xl md:text-6xl text-gold-gradient">The Prestige Game</h1>
          <div className="gold-divider my-6" />
          <p className="font-cormorant text-xl md:text-2xl text-[#f5ecd9]/75">The game you created — a playful journey through energy, elements and self-discovery — lives right here, connected to your Prestige Elements world.</p>
        </div>
      </section>

      {/* Game embed / placeholder */}
      <section className="max-w-5xl mx-auto px-5 py-8">
        <div className="card-glass rounded-3xl p-4 md:p-6">
          <div className="relative aspect-video rounded-2xl overflow-hidden bg-[#0d0a0c] border border-[#d4af37]/20 flex items-center justify-center">
            {connected ? (
              <iframe title="Prestige Game" src={connected} className="w-full h-full" allow="fullscreen; autoplay" />
            ) : (
              <div className="text-center px-6">
                <div className="h-20 w-20 mx-auto rounded-full border border-[#d4af37]/30 flex items-center justify-center mb-5 spin-slow"><Wand2 className="h-8 w-8 text-[#f0d582]" /></div>
                <p className="font-cinzel text-2xl text-gold-gradient">Your Game Loads Here</p>
                <p className="font-jost text-sm text-[#f5ecd9]/50 mt-2 max-w-md mx-auto">Paste the link to your published game below to embed it directly on the site — or we can wire it to your custom domain.</p>
              </div>
            )}
          </div>
        </div>

        {/* Connect form */}
        <form onSubmit={connect} className="card-glass rounded-2xl p-6 mt-6 flex flex-col sm:flex-row gap-3 items-stretch">
          <div className="flex items-center gap-2 flex-1 bg-white/5 border border-[#d4af37]/30 rounded-md px-4">
            <Link2 className="h-4 w-4 text-[#f0d582]" />
            <input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://your-game-url.com" className="flex-1 bg-transparent py-3 text-sm text-[#f5ecd9] placeholder:text-[#f5ecd9]/40 focus:outline-none" />
          </div>
          <button type="submit" className="btn-gold rounded-md px-8 py-3 text-sm font-semibold text-[#0a0708] bg-gradient-to-r from-[#d4af37] via-[#f0d582] to-[#d4af37]">Connect Game</button>
        </form>
      </section>

      {/* Perks */}
      <section className="max-w-6xl mx-auto px-5 py-12">
        <div className="grid md:grid-cols-3 gap-7">
          {[
            { icon: Trophy, t: 'Earn Rewards', d: 'Play to unlock exclusive discounts and cosmic perks on the shop.' },
            { icon: Link2, t: 'Two-Way Sync', d: 'Your game progress connects to your Prestige account and back again.' },
            { icon: Sparkles, t: 'Elemental Play', d: 'A holistic experience woven from the same energy as our products.' },
          ].map((p) => (
            <div key={p.t} className="card-glass rounded-2xl p-8 text-center hover-lift">
              <div className="h-14 w-14 mx-auto rounded-full border border-[#d4af37]/30 flex items-center justify-center mb-4"><p.icon className="h-6 w-6 text-[#f0d582]" /></div>
              <h3 className="font-cinzel text-lg text-[#f5ecd9] mb-2">{p.t}</h3>
              <p className="font-jost text-sm text-[#f5ecd9]/60">{p.d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Game;
